import fetch from 'cross-fetch'
import qs from 'qs'

const MAP_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

function getCoordinates () {
  return new Promise((resolve, reject) => {
    if (!navigator || !navigator.geolocation) reject(new Error('Geolocation API not available'))
    navigator.geolocation.getCurrentPosition(resolve, reject)
  })
}

export default {
  /**
   * Use Google's Geocoding API to get geolocation, city, postal code.
   * If no coordinates are provided, HTML5 Location API will prompt for user's geocoordinates.
   * @return {Object} zip, latlng, error
   */
  async get (coords) {
    const data = {
      zip: '',
      latlng: '',
      error: null
    }
    try {
      if (!coords) {
        const geo = await getCoordinates()
        coords = `${geo.coords.latitude},${geo.coords.longitude}`
      }

      data.latlng = coords

      const res = await this.post({
        latlng: data.latlng,
        key: process.env.MAP_KEY
      })

      if (!res.results || !res.results.length) {
        throw new Error('map api is unable to get zip code')
      }

      data.zip = res.results[0].address_components.filter(part => part.types[0] === 'postal_code')[0]?.long_name
      data.city = res.results[0].address_components.filter(part => part.types[0] === 'locality')[0]?.long_name
      data.country = res.results[0].address_components.filter(part => part.types[0] === 'country')[0]?.short_name

      if (data.country !== 'US') {
        throw new Error(`country ${data.country} is not supported.`)
      }
    } catch (err) {
      data.error = err && err.message
      console.warn(`geo get: ${data.error}`)
    }
    return data
  },

  post: params => {
    const url = MAP_URL + '?' + qs.stringify(params)
    return fetch(url, {
      method: 'POST'
    }).then(r => {
      if (!r.ok) {
        return r.text().then(text => {
          let error = text
          try {
            error = JSON.parse(text).errors[0].message
          } catch (err) {}
          throw new Error(error)
        })
      }
      return r.json()
    })
  },

  /**
   * Convert zip to latlng using Google API
   * @return {String} latlng, error
   */
  async zipToGeo (zip) {
    const components = `postal_code:${zip}|country:US`
    const data = {
      latlng: '',
      error: null
    }

    try {
      const res = await this.post({
        components,
        key: process.env.MAP_KEY
      })

      if (res.status !== 'OK') {
        return { error: res.status }
      }

      if (!res.results || !res.results.length) return

      const location = res.results[0].geometry.location
      data.latlng = `${location.lat},${location.lng}`
      data.city = res.results[0].address_components.filter(part => part.types[0] === 'locality')[0].long_name
      return data
    } catch (err) {
      data.error = err && err.message
      console.warn(`geo zipToGeo: ${data.error}`)
    }

    return data
  },

  async addressToGeo (address) {
    const data = {}
    try {
      const response = await this.post({
        address,
        key: process.env.MAP_KEY
      })

      const location = response.results[0].geometry.location
      data.latlng = `${location.lat},${location.lng}`
    } catch (err) {
      data.error = err && err.message
    }

    return data
  }
}
